<template>
  <f7-page>
    <template #fixed>
      <TheNavbar
        :nav-title="$t('404.notFound')"
        class="secondary-navbar"
        :back-btn-enable="true"
      />
    </template>

    <f7-block strong>
      <p>{{ $t('404.sorry') }}</p>
      <p>{{ $t('404.contentNotFound') }}</p>
    </f7-block>
  </f7-page>
</template>

<script setup>
// @ts-check
import TheNavbar from '@/components/TheNavbar.vue';
</script>
